import { Box, Spacer, Spinner, VStack } from "@chakra-ui/react"
import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import { useUserPathReportCardQuery } from "../../api/generated"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { createPathFromItems } from "../utils"
import ReportPathList from "./ReportPathList"
import ReportPathStats from "./ReportPathStats"

export const UserReportCard = ({ pathId }: { pathId: number }) => {
  const { me } = usePathwrightContext()

  const { data, error, loading } = useUserPathReportCardQuery({
    variables: {
      id: pathId
    },
    skip: !pathId || !me,
    fetchPolicy: "cache-and-network"
  })

  const pathItems = data?.path
    ? createPathFromItems(data.path!.items!.edges!.map((e) => e!.node!))
    : []

  // Possibly user is looking at a default Path that has no associated user.
  const user = data?.path?.user || me

  return (
    <Box w="full">
      {(loading && !data) || !pathId ? (
        <VStack w="100%" h="200px !important" justifyContent="center">
          <Spinner />
        </VStack>
      ) : error ? (
        <BlankSlate
          icons={null}
          heading="An unexpected error occurred"
          body={(error && error!.message) || error}
        />
      ) : data?.path ? (
        <VStack w="100%" spacing={4}>
          <Box
            as="header"
            textAlign="center"
            py={2}
            px={4}
            borderRadius="card"
            bg="whiteAlpha.600"
          >
            <Avatar user={user} />
            <Text.H4>{user!.full_name}</Text.H4>
            <Text.Meta>{user!.email}</Text.Meta>
          </Box>
          <ReportPathStats performance={data!.path!.performance!} />
          <ReportPathList pathItems={pathItems} />
          <Spacer />
        </VStack>
      ) : (
        <BlankSlate icons={null} heading="Unable to load Path Performance." />
      )}
    </Box>
  )
}

const UserReportCardCard = ({
  card,
  pathId
}: {
  card: any
  pathId: number
}) => {
  return (
    <Card card={card}>
      <UserReportCard pathId={pathId} />
    </Card>
  )
}

UserReportCardCard.displayName = "UserReportCardCard"

UserReportCardCard.propTypes = {
  pathId: PropTypes.number.isRequired
}

export default UserReportCardCard
